(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9872],{

/***/ 40341:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
__webpack_unused_export__=y;


/***/ }),

/***/ 65122:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  /* unused reexport */ __webpack_require__(40341);
} else {}


/***/ }),

/***/ 43577:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car-list",
      function () {
        return __webpack_require__(31505);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js + 2 modules
var Breadcrumbs = __webpack_require__(7885);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/constants.ts
var constants = __webpack_require__(45053);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(90387);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./reusable/icons/BreadCrumbsIcon.tsx

var SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "4",
        height: "8",
        viewBox: "0 0 4 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.5 7L0.5 4L3.5 1",
            stroke: "#D5D5D5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var BreadCrumbsIcon = (SvgComponent);

;// CONCATENATED MODULE: ./common/BreadCrumbsData.tsx
var BreadCrumbsData = {
    PrivacyPolicy: {
        links: [
            {
                title: "מדיניות הפרטיות",
                link: "/privacy-policy"
            }, 
        ]
    },
    TermsOfUse: {
        links: [
            {
                title: "תנאי שימוש",
                link: "/terms-of-use"
            }, 
        ]
    },
    Accessibility: {
        links: [
            {
                title: "הצהרת נגישות",
                link: "/accessibility"
            }, 
        ]
    },
    SiteMap: {
        links: [
            {
                title: "מפת אתר",
                link: "/sitemap"
            }
        ]
    },
    Recall: {
        links: [
            {
                title: "קריאות חוזרות",
                link: "/recall"
            }, 
        ]
    },
    Warranty: {
        links: [
            {
                title: "כתב אחריות",
                link: "/warranty"
            }, 
        ]
    },
    ServiceInstructions: {
        links: [
            {
                title: "הוראות שירות",
                link: "/service-instructions"
            }, 
        ]
    },
    WarrantyExtension: {
        links: [
            {
                title: "בדיקת תכולת הארכת אחריות",
                link: "/warranty-extension"
            }
        ]
    },
    SparePriceList: {
        links: [
            {
                title: "מחירון מוצרי תעבורה",
                link: "/spare-price-list"
            }, 
        ]
    },
    ColorCode: {
        links: [
            {
                title: "קוד צבע",
                link: "/color-code"
            }, 
        ]
    },
    Hamesayat: {
        links: [
            {
                title: "המסייעת",
                link: "/hamesayat"
            }, 
        ]
    },
    VideoTutorials: {
        links: [
            {
                title: "סרטוני הדרכה ותפעול",
                link: "/video-tutorials"
            }, 
        ]
    },
    ServicesCenters: {
        links: [
            {
                title: "מרכזי שירות",
                link: "/services-centers"
            }, 
        ]
    },
    ShowRooms: {
        links: [
            {
                title: "אולמות תצוגה",
                link: "/show-rooms"
            }, 
        ]
    },
    CarList: {
        links: [
            {
                title: "מחירון מכוניות",
                link: "/car-list"
            }, 
        ]
    },
    Insurance: {
        links: [
            {
                title: "ביטוח",
                link: "/insurance"
            }, 
        ]
    },
    CarFleets: {
        links: [
            {
                title: "ציי רכב",
                link: "/car-fleets"
            }, 
        ]
    },
    ContactUs: {
        links: [
            {
                title: "צרו קשר",
                link: "/contact-us"
            }, 
        ]
    },
    ServicePlans: {
        links: [
            {
                title: "תוכנית טיפול",
                link: "/service-plans"
            }, 
        ]
    }
};


// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./common/bit/utils/slugify.ts
var slugify = __webpack_require__(38730);
;// CONCATENATED MODULE: ./common/BreadCrumbs.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n\n  ",
        " {\n  }\n  ",
        " {\n    position: absolute;\n\n    ",
        ";\n    ",
        ";\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  max-width: 1400px;\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n    display: flex;\n    justify-content: flex-start;\n    padding-right: 20px;\n  }\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n  }\n  svg {\n    margin-top: 2px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 10px;\n  font-weight: 300;\n  letter-spacing: normal;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var SINGLE_SERVICE = "singleService";
var CONFIGURATOR = "configurator";
var StyledInnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledInnerWrapper",
    componentId: "sc-e82e91a2-0"
})(_templateObject(), function(p) {
    return p.$page === SINGLE_SERVICE && "top: -20px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 25px";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "right: 50px;";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "top: -10px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 0px";
});
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledWrapper",
    componentId: "sc-e82e91a2-1"
})(_templateObject1(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$page) !== CONFIGURATOR && "width: 100%;";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$page === CONFIGURATOR && "margin-top: -50px";
}, function(p) {
    return p.$page === CONFIGURATOR && (p === null || p === void 0 ? void 0 : p.$pathname) !== constants/* STEPS_EN.summary */.Ws.summary && "margin-right: 50px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "padding-right: 15px;";
}, function(p) {
    return p.$pathname === constants/* STEPS_EN.color */.Ws.color && "padding-right: 16px";
});
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    displayName: "BreadCrumbs__StyledLink",
    componentId: "sc-e82e91a2-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.disable;
});
var BreadCrumbsWrapper = function(param) {
    var name = param.name, modelName = param.modelName, id = param.id, page = param.page, pathname = param.pathname;
    var router = (0,client_router.useRouter)();
    var carLinkUrl = function() {
        var carLink = "/model/[modelId]/[modelSlug]".replace("[modelId]", id.toString()).replace("[modelSlug]", (0,slugify/* default */.Z)(modelName));
        return carLink;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        $page: page,
        $pathname: pathname,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerWrapper, {
            $page: page,
            children: [
                BreadCrumbsData[name] && !modelName && !id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        BreadCrumbsData[name].links.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                color: "inherit",
                                href: item.link,
                                "aria-current": index === BreadCrumbsData[name].links.length - 1 && page !== SINGLE_SERVICE ? "page" : "step",
                                children: item.title
                            }, index);
                        }),
                        page === SINGLE_SERVICE && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: router.asPath,
                            "aria-current": "page",
                            children: router.query.serviceCenterSlug.toString().replace(/-/g, " ")
                        })
                    ]
                }),
                modelName && id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/models",
                            children: "לכל הדגמים"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: carLinkUrl(),
                            "aria-current": page !== CONFIGURATOR ? "page" : "step",
                            children: modelName
                        }),
                        page && page === CONFIGURATOR && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: router.asPath,
                            "aria-current": "page",
                            children: "התאמה אישית ורכישה"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var BreadCrumbs = (BreadCrumbsWrapper);


/***/ }),

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 86040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ StyledHeaderH1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57402);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  ",
        " {\n    text-align: right;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: ",
        ";\n  margin-top: ",
        ";\n  word-break: ",
        ';\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n  color: ',
        ";\n  ",
        " {\n    text-align: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  margin-top: 20px;\n  font-weight: 300;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  margin-top: 20px;\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 27px;\n  color: ',
        ";\n  width: ",
        ";\n  margin: auto;\n  ",
        ";\n  ",
        " {\n    text-align: right;\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 0.5px;\n  background-color: ",
        ";\n  margin-top: 40px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var StyledCenterText = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CenterText__StyledCenterText",
    componentId: "sc-cd579a81-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledHeaderH1 = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "h1"
}).withConfig({
    displayName: "CenterText__StyledHeaderH1",
    componentId: "sc-cd579a81-1"
})(_templateObject1(), function(p) {
    return p.$margin ? "center" : "center";
}, function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "0";
}, function(p) {
    return p.$break && p.$break;
}, function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$align ? p.$align : "right";
});
var StyledHeaderSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "CenterText__StyledHeaderSubtitle",
    componentId: "sc-cd579a81-2"
})(_templateObject2());
var StyledBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "CenterText__StyledBody",
    componentId: "sc-cd579a81-3"
})(_templateObject3(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.$page === "color" ? "500px" : "985px";
}, function(p) {
    return p.$margin && "margin-top: 20px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledLine = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CenterText__StyledLine",
    componentId: "sc-cd579a81-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.darkGrey;
});
var StyledFooterText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "CenterText__StyledFooterText",
    componentId: "sc-cd579a81-5"
})(_templateObject5());
var CenterText = function(param) {
    var title = param.title, subtitle = param.subtitle, headerText = param.headerText, footerText = param.footerText, withBorder = param.withBorder, margin = param.margin, page = param.page;
    var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .useIsDesktop */ .Ce)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledCenterText, {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeaderH1, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeaderSubtitle, {
                children: subtitle
            }),
            headerText.map(function(text) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBody, {
                    $margin: margin,
                    $page: page,
                    children: text
                }, text);
            }),
            footerText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledFooterText, {
                children: footerText
            }) : null,
            isDesktop && withBorder && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLine, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CenterText);


/***/ }),

/***/ 63358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13328);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: relative;\n  height: 150px;\n  ",
        " {\n    height: 270px;\n    ",
        ";\n  }\n  img {\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ImageContainer__StyledImageContainer",
    componentId: "sc-4c5af28c-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$collapseOpen && "margin-top: 63px";
});
var ImageContainer = function(param) {
    var src = param.src;
    var collapseOpen = (0,store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)(function(state) {
        return state.collapseLayout;
    }).collapseOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImageContainer, {
        $collapseOpen: collapseOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            src: src,
            layout: "fill",
            priority: true,
            alt: "page-cover-img",
            role: "presentation",
            "aria-hidden": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageContainer);


/***/ }),

/***/ 31505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ car_list; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./common/BreadCrumbs.tsx + 2 modules
var BreadCrumbs = __webpack_require__(15738);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./reusable/wrappers/CenterText.tsx
var CenterText = __webpack_require__(86040);
// EXTERNAL MODULE: ./reusable/wrappers/ImageContainer.tsx
var ImageContainer = __webpack_require__(63358);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(19393);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Table/Table.js
var Table = __webpack_require__(82302);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableBody/TableBody.js
var TableBody = __webpack_require__(99613);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableCell/TableCell.js
var TableCell = __webpack_require__(88222);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableContainer/TableContainer.js
var TableContainer = __webpack_require__(56847);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableHead/TableHead.js
var TableHead = __webpack_require__(83750);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableRow/TableRow.js
var TableRow = __webpack_require__(57394);
// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./common/bit/utils/slugify.ts
var slugify = __webpack_require__(38730);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/pages/CarListWrapper.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  display: grid;\n  grid-template-columns: 392px 701px;\n  grid-gap: 65px;\n  text-align: center;\n  padding-bottom: 60px;\n\n  ",
        " {\n    flex-direction: column;\n    grid-gap: 20px;\n    box-sizing: border-box;\n    padding: 60px 0;\n    grid-template-columns: 1fr;\n    margin-right: 10px;\n    margin-left: 10px;\n    border-bottom: ",
        ";\n  }\n\n  td,\n  th {\n    border: 1px solid ",
        ";\n  }\n  th {\n    background-color: ",
        ";\n  }\n  td {\n    background-color: transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "MazdaType";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 29px;\n  letter-spacing: 0.06em;\n  margin: 0;\n  margin-bottom: 10px;\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 140%;\n  color: ',
        ";\n  ",
        " {\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "MazdaType";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 140%;\n  /* or 22px */\n  color: ',
        ";\n  ",
        " {\n    padding-right: 5px;\n    padding-left: 5px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 140%;\n  color: ",
        ";\n  text-align: right;\n  ",
        " {\n    width: 600px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin-left: 20px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}













var StyledItemContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CarListWrapper__StyledItemContainer",
    componentId: "sc-6ca4ab77-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(param) {
    var $hasBorder = param.$hasBorder;
    return $hasBorder ? "1px solid #e7e7e7" : "none";
}, function(p) {
    return p.theme.colors.darkGrey;
}, function(p) {
    return p.theme.colors.white;
});
var StyledCarHeader = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "CarListWrapper__StyledCarHeader",
    componentId: "sc-6ca4ab77-1"
})(_templateObject1());
var StyledCarImage = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
    displayName: "CarListWrapper__StyledCarImage",
    componentId: "sc-6ca4ab77-2"
})(_templateObject2());
var StyledHeader = (0,styled_components_browser_esm/* default */.ZP)(TableCell/* default */.Z).withConfig({
    displayName: "CarListWrapper__StyledHeader",
    componentId: "sc-6ca4ab77-3"
})(_templateObject3(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledTD = (0,styled_components_browser_esm/* default */.ZP)(TableCell/* default */.Z).withConfig({
    displayName: "CarListWrapper__StyledTD",
    componentId: "sc-6ca4ab77-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledTableFooter = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "CarListWrapper__StyledTableFooter",
    componentId: "sc-6ca4ab77-5"
})(_templateObject5(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    displayName: "CarListWrapper__StyledBox",
    componentId: "sc-6ca4ab77-6"
})(_templateObject6(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledTableContainer = (0,styled_components_browser_esm/* default */.ZP)(TableContainer/* default */.Z).withConfig({
    displayName: "CarListWrapper__StyledTableContainer",
    componentId: "sc-6ca4ab77-7"
})(_templateObject7());
var CarListWrapper = function(param) {
    var modelsData = param.modelsData, carModel = param.carModel, index = param.index, additionalPriceForColor = param.additionalPriceForColor;
    var onCarChoose = function() {
        localStorage.setItem("topPosition", window.pageYOffset.toString());
    };
    (0,react.useEffect)(function() {
        if (localStorage.getItem("topPosition")) {
            var top = parseInt(localStorage.getItem("topPosition"));
            window.scrollTo({
                top: top,
                behavior: "auto"
            });
            localStorage.removeItem("topPosition");
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItemContainer, {
        $hasBorder: index !== modelsData.carModels.length - 1,
        onClick: onCarChoose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                href: "/model/".concat(carModel.id.toString(), "/").concat((0,slugify/* default */.Z)(carModel.name)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBox, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarHeader, {
                            children: carModel.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarImage, {
                            src: carModel.imagePriceList.imageUrl,
                            alt: carModel.imagePriceList.alt,
                            width: "392px",
                            height: "198px",
                            role: "presentation",
                            "aria-hidden": "true"
                        })
                    ]
                })
            }, index.toString()),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                                        align: "center",
                                        children: "מנוע ורמת גימור"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                                        align: "center",
                                        children: 'מחיר כולל מע"מ '
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                                        align: "center",
                                        children: "אגרת רישוי"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
                                        align: "center",
                                        children: [
                                            'מחיר כולל מע"מ ואגרת רישוי',
                                            " "
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                            children: carModel.carModelsPriceLists.map(function(row, ind) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTD, {
                                            align: "center",
                                            children: [
                                                row.engineShortName,
                                                " ",
                                                row.finishingLevelName
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTD, {
                                            align: "center",
                                            children: [
                                                "₪",
                                                row.price.toLocaleString()
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTD, {
                                            align: "center",
                                            children: [
                                                "₪",
                                                row.registrationFee.toLocaleString()
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTD, {
                                            align: "center",
                                            children: [
                                                "₪",
                                                (row.price + row.registrationFee).toLocaleString()
                                            ]
                                        })
                                    ]
                                }, ind.toString());
                            })
                        })
                    ]
                })
            }),
            index === modelsData.carModels.length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableFooter, {
                children: additionalPriceForColor
            }) : null
        ]
    });
};
/* harmony default export */ var pages_CarListWrapper = (CarListWrapper);

;// CONCATENATED MODULE: ./components/pages/CarListPage.tsx

function CarListPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    CarListPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CarListPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  display: flex;\n  align-items: center;\n  background: ",
        ";\n  padding-bottom: 80px;\n  input {\n    padding-left: 0px;\n    padding-right: 0px;\n    background-color: white;\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n  }\n  .MuiTextField-root {\n    margin-top: 20px;\n    width: 320px;\n    ",
        " {\n      width: 100%;\n    }\n  }\n"
    ]);
    CarListPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CarListPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 40px;\n  width: 1160px;\n  ",
        " {\n    padding-right: 20px;\n    padding-left: 20px;\n    width: 100%;\n  }\n"
    ]);
    CarListPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CarListPage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 60px;\n  ",
        " {\n    height: 0px;\n  }\n"
    ]);
    CarListPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CarListPage_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 27px;\n  color: ',
        ";\n  width: 985px;\n  margin: auto;\n  text-align: center;\n  margin-top: 20px;\n  ",
        " {\n    width: 100%;\n    margin-top: 10px;\n  }\n"
    ]);
    CarListPage_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CarListPage__StyledWrapper",
    componentId: "sc-40397928-0"
})(CarListPage_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledPageDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CarListPage__StyledPageDiv",
    componentId: "sc-40397928-1"
})(CarListPage_templateObject1(), function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledTextWrapp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CarListPage__StyledTextWrapp",
    componentId: "sc-40397928-2"
})(CarListPage_templateObject2(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledSpace = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CarListPage__StyledSpace",
    componentId: "sc-40397928-3"
})(CarListPage_templateObject3(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledBody = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "CarListPage__StyledBody",
    componentId: "sc-40397928-4"
})(CarListPage_templateObject4(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var CarListPage = function(param) {
    var modelsData = param.modelsData;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var title = "מחירון דגמי מאזדה";
    var headerText = modelsData === null || modelsData === void 0 ? void 0 : modelsData.annualPriceCatalogText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageDiv, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer/* default */.Z, {
                    src: isDesktop ? "/img/carprice.jpg" : "/img/carpricemobile.jpg"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                    name: "CarList"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTextWrapp, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CenterText/* StyledHeaderH1 */.O, {
                            $align: "center",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBody, {
                            children: headerText
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpace, {}),
                modelsData.carModels.map(function(carModel, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(pages_CarListWrapper, {
                        modelsData: modelsData,
                        carModel: carModel,
                        index: index,
                        additionalPriceForColor: modelsData === null || modelsData === void 0 ? void 0 : modelsData.additionalPriceForColor
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var pages_CarListPage = (CarListPage);

// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
;// CONCATENATED MODULE: ./src/pages/car-list.tsx

function car_list_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding-top: ",
        "px;\n  flex-direction: column;\n  background-color: ",
        ";\n  ",
        " {\n    padding-top: ",
        "px;\n  }\n"
    ]);
    car_list_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledPageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "car-list__StyledPageWrapper",
    componentId: "sc-4527d430-0"
})(car_list_templateObject(), shared/* HEADER_HEIGHT_M */.Gi, function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, shared/* HEADER_HEIGHT_D */.gw);
var Models = function(param) {
    var seo = param.seo, modelsData = param.modelsData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_CarListPage, {
                    modelsData: modelsData
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var car_list = (Models);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6808,9774,2888,179], function() { return __webpack_exec__(43577); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);